import React from "react";
import { List, LayoutGrid } from "lucide-react";

const OPTIONS = [
  { value: "table", icon: List, label: "Table view" },
  { value: "card", icon: LayoutGrid, label: "Card view" },
];

export default function ViewToggle({ viewMode, onChange, height, buttonSize }) {
  const controlHeight = height || 32;
  const optionSize = buttonSize || 26;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        border: "1px solid #2a2a2e",
        borderRadius: height ? 10 : 8,
        padding: 2,
        height: controlHeight,
        boxSizing: "border-box",
      }}
    >
      {OPTIONS.map((opt, index) => {
        const Icon = opt.icon;
        const active = viewMode === opt.value;
        return (
          <button
            key={opt.value}
            type="button"
            aria-label={opt.label}
            onClick={() => onChange(opt.value)}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              width: height ? optionSize : 28,
              height: optionSize,
              marginLeft: index === 0 ? 0 : 2,
              borderRadius: 6,
              background: active ? "rgba(0,173,181,0.15)" : "transparent",
              border: "none",
              color: active ? "#00ADB5" : "#c3c8cc",
              cursor: "pointer",
              transition: "background 0.15s, color 0.15s",
            }}
          >
            <Icon size={14} />
          </button>
        );
      })}
    </div>
  );
}
